module["exports"] = [
  "West-Vlaanderen",
  "Oost-Vlaanderen",
  "Vlaams-Brabant",
  "Antwerpen",
  "Limburg",
  "Brussel"
];
